<template>
  <div class="water-on-paper-parameters">
    <s-empty-list
      v-if="!tabInfo.windingAmount"
      class="water-on-paper-parameters__empty-list"
    />
    <view-edit-panel
      v-else
      class="water-on-paper-parameters-data px-0"
      permission-to-edit="PER013"
      saving-success-code="MS032"
      hide-edit-when-without-permission
      :value="formData"
      :disable-save="isFormInvalid"
      :loading="loading"
      @changing="save"
    >
      <div
        slot-scope="data"
        class="col-12"
      >
        <parameters-form
          :parameters="data.item.parameters"
          :windings="data.item.windings"
          :original-data="formData"
          :edit-mode="data.editing"
          :is-loading="loading"
          :is-saving="saving"
          :key="formKey"
          @force-rerender-form="forceRerenderForm"
          @invalid-form="invalidFormHandler"
        />
      </div>
    </view-edit-panel>
  </div>
</template>

<script>
import { EquilibriumCurve } from 'sigma-mappings';
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import Service from '@/domain/services/installation/engineering/waterOnPaper/waterOnPaperService';
import ViewEditPanel from '@/components/ViewEditPanel';
import ParametersForm
  from '@/domain/components/installation/engineering/waterOnPaper/ParametersForm';

export default {
  name: 'WaterOnPaperParametersTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ViewEditPanel,
    ParametersForm,
  },
  data: () => ({
    parameters: {},
    windings: [],
    equilibriumCurve: EquilibriumCurve,
    loading: false,
    saving: false,
    isFormInvalid: false,
    formKey: 0,
  }),
  computed: {
    assetModuleId() {
      const { assetModuleId } = this.$route.params;
      return assetModuleId;
    },
    formData() {
      return {
        parameters: this.parameters,
        windings: this.windings,
      };
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData, this);
      this.refreshData(true);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.windingAmount) return;
      this.loading = showLoading;

      Promise.allSettled([
        this.getParameters(),
        this.getWindingsPromises(),
      ])
        .finally(() => {
          this.loading = false;
        });
    },
    getParameters(showLoading = false) {
      this.loading = showLoading;

      return Service.getParameters(this.assetModuleId)
        .then((response) => {
          this.parameters = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getWindingsPromises() {
      const promises = [];

      for (let index = 1; index <= this.tabInfo.windingAmount; index += 1) {
        promises.push(Service.getWindingParameters(this.assetModuleId, index));
      }

      return Promise.allSettled(promises)
        .then((response) => {
          for (let index = 0; index < response.length; index += 1) {
            this.$set(this.windings, index, response[index].value);
          }
        });
    },
    save({ newValue, accept, reject }) {
      this.saving = true;

      const payload = {
        ...newValue.parameters,
        windings: newValue.windings,
      };

      return Service.putParameters(this.assetModuleId, payload)
        .then((response) => {
          accept(response);
          this.refreshData(true);
          this.forceRerenderForm();
        })
        .catch(reject)
        .finally(() => {
          this.saving = false;
        });
    },
    invalidFormHandler(value) {
      this.isFormInvalid = value;
    },
    forceRerenderForm() {
      this.formKey += 1;
    },
  },
};
</script>

<style lang="sass" scoped>
.water-on-paper-parameters
  &__empty-list
    display: flex
    flex-direction: column
    justify-content: center
    height: 415px
</style>
